(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('IBM', IBM);

    /* @ngInject */
    function IBM($http) {
        var resourceUrl = 'ibm/api/v1/';

        var service = {
            getLocations: getLocations,
            getTopics: getTopics,
            getAssets: getAssets,
            getAssetById: getAssetById,
            getParts: getParts,
            updateAsset: updateAsset,
            linkJobAssets: linkJobAssets,
            linkTicketAssets: linkTicketAssets,
            linkAirSessionAssets: linkAirSessionAssets,
            resolveAirSessionId: resolveAirSessionId,
            parseAssetsResponse: parseAssetsResponse,
            getAssetsForAirSession: getAssetsForAirSession,
            handleIBMRedirect: handleIBMRedirect,
            inheritTopic: inheritTopic
        };
        return service;

        function getLocations(params) {
            return $http.get(resourceUrl + 'locations/', { params: params });
        }

        function getTopics() {
            return $http.get(resourceUrl + 'topics/tree');
        }

        function updateAsset(id, payload) {
            return $http.patch(resourceUrl + 'assets/' + id, payload);
        }

        function linkJobAssets(jobId, payload) {
            return $http.patch(resourceUrl + 'fo/jobs/' + jobId + '/assets/link', payload);
        }

        function linkTicketAssets(ticketId, payload) {
            return $http.patch(resourceUrl + 'fo/tickets/' + ticketId + '/assets/link', payload);
        }

        function linkAirSessionAssets(airSessionId, payload) {
            return $http.patch(resourceUrl + 'fo/airsessions/' + airSessionId + '/assets/link', payload);
        }

        function resolveAirSessionId(sessionOrId) {
            if (sessionOrId == null) {
                return null;
            }
            if (typeof sessionOrId === 'string' || typeof sessionOrId === 'number') {
                var directId = String(sessionOrId).trim();
                return directId === '' ? null : directId;
            }
            if (sessionOrId.id != null && String(sessionOrId.id).trim() !== '') {
                return String(sessionOrId.id);
            }
            if (sessionOrId.guid != null && String(sessionOrId.guid).trim() !== '') {
                return String(sessionOrId.guid);
            }
            if (sessionOrId._id != null && String(sessionOrId._id).trim() !== '') {
                return String(sessionOrId._id);
            }
            return null;
        }

        function parseAssetsResponse(result) {
            var data = result && result.data != null ? result.data : result;
            if (Array.isArray(data)) {
                return data;
            }
            if (data && Array.isArray(data.assets)) {
                return data.assets;
            }
            return [];
        }

        function getAssetsForAirSession(sessionOrId) {
            var airsessionId = resolveAirSessionId(sessionOrId);
            if (!airsessionId) {
                return $http.reject({ message: 'Missing air session id' });
            }
            return getAssets({ airsession: airsessionId });
        }

        function getAssets(params) {
            return $http.get(resourceUrl + 'assets/', { params: params });
        }

        function getAssetById(id) {
            return $http.get(resourceUrl + 'assets/' + encodeURIComponent(id));
        }

        function getParts(params) {
            return $http.get(resourceUrl + 'parts/', { params: params });
        }

        function handleIBMRedirect(assetId) {
            var url = window.location.origin + '/ibm/asset-detail/' + assetId;
            window.open(url, '_blank');
        }

        function inheritTopic(parentTopicId, childTopicId) {
            return $http.post(
                resourceUrl +
                    "inheritance/topic/from/" +
                    parentTopicId +
                    "/to/" +
                    childTopicId
            );
        }
    }
})();